module.exports = __webpack_public_path__ + "static/media/cf_backgrand_02.75ca4240.png";